import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSidebar } from './ducks';
import withLocale from '../../locale/withLocale';

import SidebarProducts from './SidebarProducts';
import SidebarFooter from './SidebarFooter';

class Sidebar extends Component {
  render() {
    const { toggleSidebar, sidebar, browser, header, t } = this.props;
    const toggleOnClick = browser.width < 1100;
    if (sidebar.products.length === 0) return null;
    if (!sidebar.isOpen && toggleOnClick) return null;

    return (
      <div className="sidebar small no-print" onClick={toggleOnClick ? toggleSidebar : null}>
        <div className="sidebar-container">
          <div className="sidebar-top text-right">
            <span className="button transparent icon-close no-text gray-dark" />
          </div>
          <div className="sidebar-content">
            <SidebarProducts
              items={sidebar.products}
              mobile={toggleOnClick}
              header={header.products}
              isOpen={sidebar.isOpen}
              t={t}
            />
          </div>
          <SidebarFooter toggle={toggleSidebar} isOpen={sidebar.isOpen} />
        </div>
      </div>
    );
  }
}

const mapState = ({ sidebar, browser, header }) => ({ sidebar, browser, header });

const mapDispatch = dispatch => ({
  toggleSidebar: bindActionCreators(toggleSidebar, dispatch)
});
export default withLocale(withRouter(connect(mapState, mapDispatch)(Sidebar)));



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Sidebar/index.js